var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PreventableEvent } from './preventable-event';
// tslint:disable:max-line-length
/**
 * Arguments for the `zoomStart` event.
 */
var ZoomStartEvent = /** @class */ (function (_super) {
    __extends(ZoomStartEvent, _super);
    // tslint:enable:max-line-length
    /**
     * @hidden
     */
    function ZoomStartEvent(e, target) {
        var _this = _super.call(this, target) || this;
        _this.axisRanges = e.axisRanges;
        _this.nativeEvent = e.originalEvent;
        return _this;
    }
    return ZoomStartEvent;
}(PreventableEvent));
export { ZoomStartEvent };
//# sourceMappingURL=zoom-start-event.js.map